/* ============================================================================
   PRESSROOM — COLLECTIONS "The Lineup" davranisi (FAZ 2 Parti 2, spec 3.5)
   <pressroom-collections> web component.
   - Kartlar gorunur olunca scroll-reveal (stagger CSS --_pr-delay'den) + medya
     halftone "basilir" (.is-printed).
   - Mobil (coarse pointer): hover yok -> tap CMYK/VIEW yerine "is-tapped" ile
     VIEW etiketini gosterir; ikinci tap linke gider.
   Kurallar (CLAUDE.md + spec):
   - Tek IntersectionObserver. Hardcoded yok (stagger CSS token'dan delay).
   - reduced-motion: hicbir animasyon kurma; kartlar/medya son durumda gorunur.
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COARSE = window.matchMedia('(pointer: coarse)').matches;

  customElements.define('pressroom-collections', class extends HTMLElement {
    connectedCallback() {
      this._cards = Array.prototype.slice.call(this.querySelectorAll('[data-pr-coll-card]'));
      if (this._cards.length === 0) return;

      // reduced-motion: hepsi son durumda gorunur (medya basili).
      if (REDUCED) {
        this._cards.forEach(function (card) {
          card.classList.add('is-revealed');
          var media = card.querySelector('[data-pr-coll-media]');
          if (media) media.classList.add('is-printed');
        });
        return;
      }

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(this._onIntersect.bind(this), {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.1
        });
        this._cards.forEach(function (card) { this._io.observe(card); }, this);
      } else {
        // Gozlemci yoksa hepsini ac.
        this._reveal(this._cards);
      }

      // Mobil tap-to-reveal: coarse pointer'da ilk tap VIEW/golge gosterir.
      if (COARSE) this._wireTap();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._tapHandler) this.removeEventListener('click', this._tapHandler, true);
    }

    _onIntersect(entries, obs) {
      var self = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          self._reveal([entry.target]);
          obs.unobserve(entry.target);
        }
      });
    }

    _reveal(cards) {
      cards.forEach(function (card) {
        card.classList.add('is-revealed');
        var media = card.querySelector('[data-pr-coll-media]');
        // halftone-reveal primitive: kart gorununce medyayi bas.
        if (media) media.classList.add('is-printed');
      });
    }

    _wireTap() {
      var self = this;
      this._tapHandler = function (e) {
        var card = e.target.closest('[data-pr-coll-card]');
        if (!card) return;
        // Henuz "tapped" degilse: ilk dokunus VIEW/etiketi acsin, navigasyonu durdur.
        if (!card.classList.contains('is-tapped')) {
          // Diger kartlardan tapped'i kaldir (tek seferde bir kart "aktif").
          self._cards.forEach(function (c) { if (c !== card) c.classList.remove('is-tapped'); });
          card.classList.add('is-tapped');
          e.preventDefault();
        }
        // Ikinci dokunus: link dogal calisir (preventDefault yok).
      };
      this.addEventListener('click', this._tapHandler, true);
    }
  });
})();
